window.onbeforeunload = function (event) {
	localStorage.setItem('currentScroll', currentY ? currentY : 0);
};
